<template>
    <div>
        <h2>Coming Soon</h2>
        <p>Helaas is deze functie nog niet beschikbaar. In één van de volgende updates zal deze functie beschikbaar zijn</p>
    </div>
</template>
<style scoped>
    div{
        width: 100%;
        height: 75vh;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
</style>